export default __webpack_public_path__ + "static/slider-3-bb678fb2e8c7257a35ca5f1827716989.jpg";